/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { RoutewareWizardComponentDisplay } from "cms/components/components/routeware-wizard/display";
import { RoutewareWizardComponentEditor } from "cms/components/components/routeware-wizard/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function RoutewareWizardComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <RoutewareWizardComponentDisplay />,
        editComponent: <RoutewareWizardComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

RoutewareWizardComponent.displayName = "RoutewareWizardComponent";
export { RoutewareWizardComponent };
